import { DashboardView } from "@/admin/dashboard/DashboardView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/")({
    component: DashboardView,
});
